var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.showBackgroundColor ? 'footer font12 bc' : 'footer font12'},[_vm._v(" 日浩版权所有 © "),_c('span',{staticStyle:{"font-family":"Arial"}},[_vm._v("2005-"+_vm._s(_vm.year)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }